export var VERTICAL_EMBED_TYPE = 'wix-draft-plugin-vertical-embed';
export var verticalsTypes;
(function (verticalsTypes) {
    verticalsTypes["event"] = "events";
    verticalsTypes["product"] = "products";
    verticalsTypes["booking"] = "bookings";
})(verticalsTypes || (verticalsTypes = {}));
//# sourceMappingURL=consts.js.map